module.exports = __webpack_public_path__ + "img/check-img.d966a2d2.svg";